import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import WalletProvider from './helper/Web3Provider';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WalletProvider>
      <App />
    </WalletProvider>
  </React.StrictMode>
);
